export const ADD_USER = 'ADD_USER';
export const DELETE_USER = 'DELETE_USER';
export const UPDATE_USER = 'UPDATE_USER';

export const USERS_ERROR = 'USERS_ERROR';
export const USERS_REQUEST = 'USERS_REQUEST';
export const USERS_SUCCESS = 'USERS_SUCCESS';

export const USERS_ADD_NOTIFICATION = 'USERS_ADD_NOTIFICATION';
export const USERS_CLEAN_NOTIFICATION = 'USERS_CLEAN_NOTIFICATION';
